import React from 'react';
import { Breadcrumb as BreadcrumbAntd } from 'antd';
import css from './Breadcrumb.less';
interface IProps {
  breadcrumbData: breadcrumbData[];
  className?;
}
interface breadcrumbData {
  url: string;
  name: string;
}
const Breadcrumb = (props: IProps) => {
  const { breadcrumbData, className } = props;
  return (
    <BreadcrumbAntd className={` ${className} ${css.Breadcrumb}`}>
      {breadcrumbData.map((item, index) => (
        <BreadcrumbAntd.Item key={index}>
          {item.url ? <a href={item.url}>{item.name}</a> : item.name}
        </BreadcrumbAntd.Item>
      ))}

      <BreadcrumbAntd.Item></BreadcrumbAntd.Item>
    </BreadcrumbAntd>
  );
};
export default Breadcrumb;
